import { Link } from 'react-router-dom';
import { AdminSidebar } from '../../components/Sidebar';

export default function PlanExpiredPage() {
  return (
    <div style={{ display: 'flex' }}>
      <AdminSidebar />
      <main className="main-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '80vh' }}>
        <div style={{ textAlign: 'center', maxWidth: 460 }}>
          <div style={{
            width: 72, height: 72, borderRadius: '50%',
            background: '#FEF2F2', color: '#EF4444',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 24px',
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>

          <h2 style={{ fontSize: 24, marginBottom: 12, color: 'var(--text)' }}>Testphase abgelaufen</h2>
          <p style={{ color: 'var(--text2)', lineHeight: 1.7, marginBottom: 28 }}>
            Ihre 30-tägige Testphase ist abgelaufen. Um Ilmify weiter zu nutzen und Quiz-Wettbewerbe durchzuführen, wählen Sie bitte einen Plan.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 300, margin: '0 auto' }}>
            <Link to="/admin/profile?tab=plan" className="btn btn-primary btn-lg" style={{ textAlign: 'center' }}>
              Plan auswählen
            </Link>
            <a
              href="mailto:support@ilmify.ch"
              style={{ fontSize: 14, color: 'var(--text3)', textDecoration: 'none' }}
            >
              Fragen? support@ilmify.ch
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
